import { render, staticRenderFns } from "./visits.page.vue?vue&type=template&id=44c100c7&scoped=true"
import script from "./visits.page.vue?vue&type=script&lang=js"
export * from "./visits.page.vue?vue&type=script&lang=js"
import style0 from "./visits.page.vue?vue&type=style&index=0&id=44c100c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c100c7",
  null
  
)

export default component.exports